import React from 'react';
import classNames from 'classnames';
import { cloneDeep } from 'lodash';
import { tenantsModalCopy as copy } from '../../../copy/advisor-dashboard/tenants-tab.json';

export class DashboardButton extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      isDropdown: false,
      buttonLabel: '',
      buttonValue: '',
      subButtons: [],
    };
  }

  componentDidMount = () => {
    const { button } = this.props;
    if (button[0]) {
      if (Object.keys(button[0]).includes('label')) {
        this.setState({
          buttonLabel: button[0].label,
          buttonValue: button[0].value,
        });
      } else {
        const buttonLabel = Object.keys(button[0])[0];
        this.setState({
          buttonLabel,
          subButtons: button[0][buttonLabel],
          isDropdown: true,
        });
      }
    }
  };

  handleInputChange = (id, e) => {
    this.setState({
      [id]: e,
    });
  };

  handleIsDropdown = (currentVal) => {
    this.setState({
      isDropdown: !currentVal,
    });
    if (!currentVal && this.state.subButtons.length === 0) {
      this.addSubButton();
    }
  };

  labelAndInput = (id, label, className) => {
    return (
      <div className={classNames('tenant-modal__label-and-input', className)}>
        <label className="tenant-modal__label" htmlFor={id}>
          {label}
        </label>
        <input
          className="tenant-modal__input"
          id={id}
          value={this.state[id]}
          onChange={(e) => {
            this.handleInputChange(id, e.target.value);
          }}
          onBlur={(e) => {
            this.props.updateButtonOnParent(
              this.props.num,
              id === 'buttonLabel' ? 'label' : 'value',
              e.target.value,
              this.state.isDropdown,
              this.state.subButtons
            );
          }}
        />
      </div>
    );
  };

  checkboxAndLabel = (label) => {
    const { isDropdown } = this.state;
    return (
      <div className="tenant-modal__checkbox-and-label tenant-modal__margin-bottom">
        <input
          type="checkbox"
          className="tenant-modal__checkbox"
          name="terms-type"
          style={this.props.colorPrimary}
          id={label}
          onClick={() => {
            this.handleIsDropdown(isDropdown);
          }}
          tabIndex={0}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) this.handleIsDropdown(isDropdown);
          }}
          onChange={() => {
            // this is to appease react, but we want an onClick here
            // rather than an onChange - despite the fact that react
            // wants us to have an onChange
          }}
          checked={isDropdown}
        />
        <label
          htmlFor={label}
          className="tenant-modal__label tenant-modal__no-margin"
        >
          {label}
        </label>
      </div>
    );
  };

  subButtons = (id, label, className, i) => {
    return (
      <div className={classNames('tenant-modal__label-and-input', className)}>
        <label className="tenant-modal__label" htmlFor={`button-${i}-${id}`}>
          {label}
        </label>
        <input
          className="tenant-modal__input"
          id={`button-${i}-${id}`}
          value={this.state.subButtons[i][id]}
          onChange={(e) => {
            this.handleSubButtonsChange(id, e.target.value, i);
          }}
          onBlur={(e) => {
            this.props.updateButtonOnParent(
              this.props.num,
              id === 'buttonLabel' ? 'label' : 'value',
              e.target.value,
              this.state.isDropdown,
              this.state.subButtons,
              this.state.buttonLabel
            );
          }}
        />
      </div>
    );
  };

  handleSubButtonsChange = (id, e, i) => {
    const { subButtons } = this.state;
    const clone = cloneDeep(subButtons);
    clone[i][id] = e;
    clone[i].buttonNumber = this.props.num;
    this.setState({
      subButtons: clone,
    });
  };

  displaySubButtons = () => {
    const { subButtons } = this.state;
    return subButtons.map((button, i) => {
      return (
        <div
          className="tenant-modal__row tenant-modal__margin-bottom"
          key={`button-${this.props.buttonNumber}-${button.order}`}
        >
          {this.subButtons(
            `label`,
            `${copy.subButtonLabel} ${i + 1} ${copy.dashButtonLabel2}`,
            'tenant-modal__leave-room',
            i,
            button.label
          )}
          {this.subButtons(
            `value`,
            `${copy.subButtonLabel} ${i + 1} ${copy.dashButtonLabel3}`,
            'tenant-modal__leave-room',
            i,
            button.value
          )}
        </div>
      );
    });
  };

  addSubButton = () => {
    const { subButtons } = this.state;
    const clone = cloneDeep(subButtons);
    clone.push({
      label: '',
      value: '',
      order: subButtons.length + 2,
      isDropdown: false,
    });
    this.setState({
      subButtons: clone,
    });
  };

  render() {
    const { isDropdown } = this.state;
    return (
      <>
        <div className="tenant-modal__dashboard-button">
          <div className="tenant-modal__row tenant-modal__margin-bottom">
            {this.labelAndInput(
              'buttonLabel',
              `${copy.dashButtonLabel1} ${this.props.num} ${copy.dashButtonLabel2}`,
              'tenant-modal__leave-room'
            )}
            {!isDropdown &&
              this.labelAndInput(
                'buttonValue',
                `${copy.dashButtonLabel1} ${this.props.num} ${copy.dashButtonLabel3}`,
                'tenant-modal__leave-room'
              )}
          </div>
          {this.checkboxAndLabel(copy.dashButtonCheckboxLabel)}
          {isDropdown && this.displaySubButtons()}
          {isDropdown && (
            <button
              onClick={this.addSubButton}
              tabIndex={0}
              type="button"
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key)) {
                  this.addSubButton();
                }
              }}
              style={this.props.colorPrimary}
              className="tenant-modal__add-subbutton tenant-modal__margin-bottom"
            >
              {copy.addSubButton}
            </button>
          )}
        </div>
        <div className="tenant-modal__hr tenant-modal__margin-bottom" />
      </>
    );
  }
}
export default DashboardButton;
